export const DRAW_MODAL = 'DRAW_MODAL';
export const REMOVE_MODAL = 'REMOVE_MODAL';
export const SHOW_MODAL = 'SHOW_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';